<script>
import { clone } from '@/service/util'
export default {
  props: {
    modalStatus: {
      type: Boolean,
      required: true
    },
    tipo: {
      type: String,
      required: true
    },
    titulo_modal: {
      type: String,
      required: true
    },
    titulo_texto: {
      type: String,
      required: false,
      default: 'ATENÇÃO'
    },
    texto: {
      type: String,
      required: false
    },
    descricao_texto: {
      type: String,
      required: false
    },
    texto_botao_acao: {
      type: String,
      required: true
    },
    data: {
      type: Object,
      required: false,
      default: null
    }
  },
  data: () => ({
    modalStatusData: false
  }),
  methods: {
    fecharModel: function () {
      this.$emit('modalFechada', false)
    },
    acaoBotao: function () {
      this.$emit('acao_concluir', this.data)
    }
  },
  watch: {
    modalStatus: function () {
      this.modalStatusData = clone(this.modalStatus)
    }
  },
  created () {
    this.modalStatusData = clone(this.modalStatus)
  }
}
</script>

<template>
  <b-modal size="md" :title="titulo_modal" @hidden="fecharModel" v-model="modalStatusData" :class="'modal-' + tipo" :hide-footer="true">
    <div class="row">
      <div class="col-lg-12 text-center mensagem">
        <h2 v-if="tipo === 'warning'"><i class="fa fa-exclamation-triangle"></i></h2>
        <h2 v-else-if="tipo === 'danger'"><i class="fa fa-exclamation-triangle"></i></h2>
        <h2 v-else-if="tipo === 'success'"><i class="fa fa-exclamation-triangle"></i></h2>
        <h5>{{ titulo_texto }}</h5>
      </div>
    </div>

    <div class="row roteiro">
      <div v-if="texto" class="col-lg-12 text-center"> {{ texto }} </div>
      <div v-if="descricao_texto" class="col-lg-12 text-center mt-2"><small> {{ descricao_texto }} </small></div>
    </div>

    <div class="row mt-3">
      <div class="col-lg-12">
        <button class="btn btn-secondary fechar" @click="fecharModel">Fechar</button>
        <button :class="'btn btn-'+ tipo +' float-right'" @click="acaoBotao">{{ texto_botao_acao }}</button>
      </div>
    </div>

  </b-modal>
</template>

<style scoped>
  .row.buttons-inativa {
    margin-top: 20px;
  }
  .roteiro {
    margin-top: 25px;
    overflow-x: hidden;
  }
  .fechar {
    margin-left: 6px;
  }
</style>



// WEBPACK FOOTER //
// modal-confirmacao.vue?48a7a580